import React, { useState } from "react";
import shareIcon from "../../assets/dasboard/share-icon.svg";
import { getColorCode, getImage } from "../../utils/utility-functions";
import ShareProfileModal from "../share-modal/component";

function ShareButton({
  currentAssessmentAttemptData,
  userGUID,
  userData,
  isRomanticCompatibility,
  assessmentAttemptResultId,
}) {
  const [selectedTest, setSelectedTest] = useState(null);

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const currentPersonalityGroup = currentAssessmentAttemptData
    ? currentAssessmentAttemptData?.personality?.role
    : "";

  const personalityColorLight = getColorCode(
    currentPersonalityGroup && currentPersonalityGroup
  ).light;

  const handleShareReport = (item) => {
    setShareModalOpen(true);
    setSelectedTest(item);
  };

  return (
    <div>
      <button
        onClick={() => {
          handleShareReport(currentAssessmentAttemptData);
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = personalityColorLight)
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
        className="aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
      >
        <img
          src={shareIcon}
          alt="Sharing"
          className="w-[40px] h-auto hover:text-insightful-purple"
        />
      </button>
      {shareModalOpen && (
        <ShareProfileModal
          isOpen={shareModalOpen}
          onClose={() => setShareModalOpen(false)}
          personalityImage={getImage(
            selectedTest?.personality?.role?.toLowerCase() &&
              selectedTest?.personality?.role?.toLowerCase(),

            selectedTest?.nameEnglishCode?.toLowerCase() &&
              selectedTest?.nameEnglishCode?.toLowerCase(),
            true,
            userData?.gender
          )}
          assessmentTitle={
            selectedTest?.title || currentAssessmentAttemptData.assessmentTitle
          }
          assessmentId={
            selectedTest?.assessmentId && selectedTest?.assessmentId
          }
          assessmentAttemptId={
            selectedTest?.assessmentAttemptId &&
            selectedTest?.assessmentAttemptId
          }
          personalityType={
            selectedTest?.personality?.title && selectedTest?.personality?.title
          }
          personalityName={
            selectedTest?.personality?.name && selectedTest?.personality?.name
          }
          personalityGroup={
            selectedTest?.personality?.role && selectedTest?.personality?.role
          }
          userGUID={userGUID}
          isRomanticCompatibility={isRomanticCompatibility}
          assessmentAttemptResultId={assessmentAttemptResultId}
        />
      )}
    </div>
  );
}

export default ShareButton;
